import React from "react";
import styled from "styled-components";
import { ResponsiveToSideNavigatorTemplate } from "App/Templates/ResponsiveToSideNavigatorTemplate";
import { HEADER_HEIGHT_PX } from "constants/size";
import { ArtistForm } from "./Forms/ArtistForm";
import { ArtistStoreProvider, useArtistStore } from "./Store";
import { ArtistCreateActions, ContentsState } from "./Store/Artist";
import { SubmitForm } from "./Forms/SubmitForm";
import { Helmet } from "App/Atomics/Helmet";

const Layout = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  text-transform: capitalize;

  width: 100%;
  height: calc(100vh - ${HEADER_HEIGHT_PX});
`;

const ViewForm = (props: { state: ContentsState }) => {
  switch (props.state) {
    case "ARTIST":
      return <ArtistForm />;
    case "SUBMIT":
      return <SubmitForm />;
    default:
      return <div></div>;
  }
};

const ArtistCreateLayout = () => {
  const [{ pageState }, dispatch] = useArtistStore(store => ({
    pageState: store.Artist.pageState
  }));

  if (!pageState) {
    dispatch(ArtistCreateActions.setPageState("ARTIST"));
  }

  return (
    <ResponsiveToSideNavigatorTemplate>
      <Layout>
        <ViewForm state={pageState} />
      </Layout>
    </ResponsiveToSideNavigatorTemplate>
  );
};

export const ArtistCreate = () => (
  <ArtistStoreProvider>
    <Helmet title="아티스트 등록" />
    <ArtistCreateLayout />
  </ArtistStoreProvider>
);
